// React
import React, { Component } from 'react';
import Alert from 'react-s-alert';
import {functions} from 'constants/index';
// Api Services
import ApiServices from 'services/ApiServices';
// Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Table from 'components/Table';
import Footer from 'pages/Home/Footer2';
import Title from 'components/TitleWithIcon';
import CustomToolTip from 'components/tooltip/';
import FormularioCreacionUsuario from './FormularioCreacionUsuario'
//material ui
import {PersonAdd} from '@material-ui/icons/';


class ModuloDeCreacionDeUsuariosEnElSSO extends Component {     
    constructor(props) {
        super(props);
        this.state = {
            controller:'user',
            loading: false,
            authorized:true,
            checkAutorization:true,
            rowData: [],
            header: [
                { title: 'ID de Registro', field: 'id',cellStyle:{ maxWidth: '80px' } },
                { title: 'No. Empleado', field: 'code',cellStyle:{ maxWidth: '80px' } },
                { title: 'Nombre', field: 'name',cellStyle:{ maxWidth: '80px' } },
                { title: 'Correo electrónico', field: 'email',cellStyle:{ maxWidth: '80px' } },
                { title: 'Usuario', field: 'userName',cellStyle:{ maxWidth: '80px' } },
                { title: 'Rol asignado', field: 'rol.name',cellStyle:{ maxWidth: '80px' } },
                { title: 'Fecha Asignación de rol', field: 'rol.createdAt',cellStyle:{ maxWidth: '80px'}, render: (rowData) => functions.splitDate(rowData.rol.createdAt)},
                { title: 'Fecha creación usuario', field: 'createdAt',cellStyle:{ maxWidth: '80px' }, render: (rowData) => functions.splitDate(rowData.createdAt)},
                // { title: 'Acción', field: 'accion',
                //     render: rowData=><div>
                //         <ButtonGroup color="primary" aria-label="outlined primary button group">
                //             <CustomToolTip title="Crear Usuario" handleFunction={() => {}}><PersonAdd/></CustomToolTip>
                //         </ButtonGroup>                        
                //     </div>            
                // },                 
            ],
            currentUser: props.currentUser,
            openFormCreateUser:false,
        }
        this.showList = this.showList.bind(this);
        this.openModalFormCreateUser = this.openModalFormCreateUser.bind(this);
        this.closeModalFormCreateUser = this.closeModalFormCreateUser.bind(this);
    }
     
    async showList(){
        try{
            this.setState({loading: true, checkAutorization: true});
            const hasPermission = await ApiServices.userSecurity.hasPermission(this.state.controller,'list');    
            if (hasPermission.error){
                this.setState({checkAutorization: false,authorized: false,loading: false });
            }else{
                ApiServices[this.state.controller].initSearchCriteria.clear();
                ApiServices[this.state.controller].initOrderCriteria.clear();
                // ApiServices[this.state.controller].initSearchCriteria.setOperator("and");              
                ApiServices[this.state.controller].initSearchCriteria.addEquals("datosSolicitudEmpadronamiento.statusSolicitud",3);
                ApiServices[this.state.controller].initOrderCriteria.addAsc("id");
                this.setState({checkAutorization: false, authorized: true,loading: false, create: false });
            }
        }catch(exception){
            (exception.status===404) ? Alert.error("Falla del sistema"): Alert.error("Intente de nuevo ");
            this.setState({ loading: false,checkAutorization: false  });
        }
    }
    async componentDidMount() {  this.showList();    }
    openModalFormCreateUser(){
        this.setState({openFormCreateUser: true})
    }
    closeModalFormCreateUser(){
        this.setState({openFormCreateUser: false})
    }
    render() {
        return (
            <div>
                <Title title="Módulo de creación de usuarios" icon={"/menu/partner.svg"}/>
                <FormularioCreacionUsuario
                    openFormCreateUser={this.state.openFormCreateUser}
                    closeModalFormCreateUser={this.closeModalFormCreateUser}
                    updateTable={this.showList}
                />
                {window.screen.width >= 1024 ? (
                    <Table  pageSize={this.state.pageSize} 
                            title={"Listado de usuarios creados"}
                            header = {this.state.header}
                            service={ApiServices[this.state.controller]}
                            refreshList={this.showList}
                            detailPanel={this.state.detailPanel}
                            addRegister={this.addRegister}
                            customTitleButtonTable={"Crear Usuario"}
                            customIconButtonTable={<PersonAdd/>}
                            customFunctionTable={this.openModalFormCreateUser}                            
                    />
                ) : ''}
                <br/><br/><br/><Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModuloDeCreacionDeUsuariosEnElSSO);